import styled from '@emotion/styled';

export const SidebarWrapper = styled.div`
  width: 389px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const FullSidebarWrapper = styled.div`
  width: 389px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 16px;
`;
export const SidebarCategoryWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 16px;
  padding: 8px;
  display: flex;
  flex-basis: 70%;
  flex-direction: column;
`;
export const SidebarCategoryScroller = styled.div`
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;
export const SidebarInfoWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 16px;
  padding: 8px;
  display: flex;
  flex-basis: 30%;
  flex-direction: column;
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  padding: 16px 8px 16px 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 16px;
`;
export const CategoryButton = styled.button`
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 28px;
  width: 100%;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primaryTextColor};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 1px;
  box-sizing: border-box;
  border: 1px solid transparent;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor};
  }
  &.active {
    border: 1px solid ${(props) => props.theme.colors.primaryColor};
    color: ${(props) => props.theme.colors.primaryColor};
  }
  &:disabled {
    color: ${(props) => props.theme.colors.primaryTextColor + '80'};
    cursor: default;
  }
  &:disabled:hover {
    color: ${(props) => props.theme.colors.primaryTextColor + '80'};
  }
`;
export const UserLineHover = styled.div`
  width: 100%;
  height: 68px;
  border-radius: 8px;
  padding: 0 8px;
  display: flex;
  align-items: stretch;
  cursor: pointer;
  &:hover {
    // .1 opacity
    background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
  }
  &.active {
    // .25 opacity
    background-color: ${(props) => props.theme.colors.primaryColor + '40'};
  }
`;
export const UserLineWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 0 12px;
  height: 100%;
  &:not(:last-of-type) {
    border-bottom: 1px solid ${(props) => props.theme.colors.gray};
  }
`;

export const OrderProductTypeButton = styled.button`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 16px */
  letter-spacing: 1px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  border-radius: 8px;
  padding: 12px;
  border: 1px solid transparent;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor};
  }
  &.active {
    border: 1px solid ${(props) => props.theme.colors.primaryColor};
    color: ${(props) => props.theme.colors.primaryColor};
  }
  &:disabled {
    color: ${(props) => props.theme.colors.primaryTextColor + '80'};
    cursor: default;
  }
`;

export const OrderInfoSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.gray};
`;

export const StyledListCard = styled.div<{ cardWidth: number }>`
  display: flex;
  gap: 8px;
  height: 72px;
  padding: 0 16px;
  align-items: center;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 8px;
  flex: 1 0 auto;
  min-width: ${(props) => props.cardWidth || 100}px;
`;
